import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import { registerOfflineWorker } from './lib/offline';
import './index.css';

// The dashboard's Brand page shows the portal in an iframe at /preview: its own
// small app (no router of the real portal, no session, no API).
const PreviewApp = lazy(() => import('./preview/PreviewApp'));
const isPreview = window.location.pathname === '/preview';

// A page load without a connection shows the offline page, not the browser's error
// (not for the inert preview frame).
if (!isPreview) registerOfflineWorker();

const app = isPreview ? (
  <Suspense fallback={null}>
    <PreviewApp />
  </Suspense>
) : (
  <App />
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Google sign-in is offered only when a client ID is configured at build time. */}
    {import.meta.env.VITE_GOOGLE_CLIENT_ID ? (
      <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID} locale="he">
        {app}
      </GoogleOAuthProvider>
    ) : (
      app
    )}
  </React.StrictMode>,
);
